import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { store, persistor } from './store';

import MainNavigator from './navigator/MainNavigator';
import Toasts from './react-component/toasts';
import DetectConnection from './components/detectConnection';

import { ToastPedido } from './components/toastPedido';

class App extends Component {
    componentDidMount() {
        Notification.requestPermission();
    }

    render() {
        return (
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <DetectConnection />
                    <MainNavigator />
                    <ToastPedido />

                    <div id="ReactModalPortal" />
                    <Toasts />
                </PersistGate>
            </Provider>
        );
    }
}

export default App;
